
export function initNav() {
  const toggle = document.querySelector(".site-header__toggle")
  const nav = toggle && document.getElementById(toggle.getAttribute("aria-controls"))
  if (!nav) return

  const setOpen = (open) => {
    nav.classList.toggle("is-open", open)
    toggle.setAttribute("aria-expanded", String(open))
  }

  toggle.addEventListener("click", () => setOpen(!nav.classList.contains("is-open")))

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || !nav.classList.contains("is-open")) return
    setOpen(false)
    toggle.focus()
  })
}
